import React, { useContext, useState } from 'react'
import { FcDvdLogo } from 'react-icons/fc'
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/auth_context';
import { Login, Service } from '../../services/api';
import pdf from '../../docs/politicas.pdf'
import Renderif from '../../components/renderif';
import Loader from '../../components/loader';
import { AlertContext } from '../../context/alert_context';
import { MdOutlineArrowForward } from 'react-icons/md'
import { BsEye, BsEyeSlash } from 'react-icons/bs';

export default function LoginView() {
  const { setUser } = useContext(AuthContext)
  const { notify } = useContext(AlertContext);
  const [state, setState] = useState({
    email: '',
    pass: '',
    loading: false,
    showPassword:false
  })
  const navigate = useNavigate();


  const onLogin = async () => {

    setState({ ...state, loading: true })
    let login = await Login({ email: state.email, password: state.pass })

    console.log(login)

    if (login?.status !== 200) {
      notify({ title: 'Login', message: 'Algo salio mal, intentalo de nuevo más tarde', type: 'error' })
      setState({ ...state, loading: false })
      return;
    }

    localStorage.setItem('token', login.data[0].api_token);
    localStorage.setItem('tokens', JSON.stringify(login.data));

    let user = await Service('POST', 'Auth/verify_token', { 'api_token': login.data[0].api_token })
    console.log(user)
    if (user?.status !== 200) {
      notify({ title: 'Login', message: 'Algo salio mal, intentalo de nuevo más tarde', type: 'error' })
      setState({ ...state, loading: false })
      return;
    }
    user.data.profiles = login.data
    setUser({ user: user.data })

    if (user.data.roles.includes("Coach")) {
      console.log("2")
      navigate('/admin');
      return
    }

    if (user.data.roles.includes("Admin")) {
      console.log("1")
      navigate('/administrador');
      return;
    }

    console.log("3")

    navigate('/client');

  }
  return (
    <>
      <Renderif isTrue={state.loading}>
        <Loader></Loader>
      </Renderif>
      <div className='continaer-fluid h-100 bacground-gray'>
        <div className='row p-0 m-0 h-100'>

          <div className='col-12 col-md-6 d-flex flex-column justify-content-center align-items-center h-100 overflow-auto'>
            <div className='bv-login-form py-3 login-form'>

              <div className='d-flex flex-column pb-5 px-3'>
                <div className='my-4 px-3'>
                  <img width={120} src='assets/logo.png'></img>
                </div>
                <div className='bold f-22 px-3'> Iniciar sesión</div>
                <div className='f-12 text-gray px-3'>Ingresa tu correo y contraseña</div>
              </div>

              {/* <div className='f-12 bold text-gray p-4 bg-light'>
              Email: cliente o admin
            </div> */}

              <div className='pt-2 px-4'>
                <div className='f-12 bold text-gray'>Email</div>
                <input value={state.email} placeholder='Ingresa tu email' onChange={(e) => {
                  setState({ ...state, email: e.currentTarget.value })
                }} className='input--light'></input>
              </div>

              <div className='pt-2 px-4'>
                <div className='f-12 bold text-gray'>
                  <div className='d-flex pb-1'>
                    Contraseña
                    <div className='col'></div>
                    <div className='bold text-primary-bien text-decoration-underline cursor-pointer' onClick={() => {
                      navigate('/recover-pass')
                    }}
                    >Olvidé mi contraseña</div>
                  </div>
                </div>
                <input type='password' placeholder='Ingresa tu contraseña' className='input--light' value={state.pass} onChange={(evt) => {
                  setState({ ...state, pass: evt.currentTarget.value })
                }}></input>
                {/* <Renderif isTrue={state.showPassword === true}>
                  <div className='bv-icon bv-icon--mid mx-2 mb-2 cursor-pointer' onClick={() => {

                    setState({ ...state, showPassword: false })

                  }}>
                    <BsEye size={30}></BsEye>
                  </div>
                </Renderif>

                <Renderif isTrue={state.showPassword === false}>
                  <div className='bv-icon bv-icon--mid mx-2 mb-2 cursor-pointer' onClick={() => {

                    setState({ ...state, showPassword: true })

                  }}>
                    <BsEyeSlash size={30}></BsEyeSlash>
                  </div>
                </Renderif> */}
              </div>





              <div className='py-3 px-4'>
                <div className='bv-cta bv-cta--primary-bien w-100' onClick={() => { onLogin() }}>
                  <div className='text-center w-100'>Ingresar</div>
                </div>

                <div className='py-3 px-4 flex-container'>
                  <hr className='line-decore mx-2' ></hr>
                  o
                  <hr className='line-decore mx-2' ></hr>
                </div>

                <div className='mb-3'>
                  <div className='f-14 text-center'>¿Eres nuevo/a en Bien Vivir? <span className='cursor-pointer text-primary-bien text-decoration-underline bold' onClick={() => {
                    navigate('/registro')
                  }}>Registrate </span><MdOutlineArrowForward size={20} color={'#0270fc'}></MdOutlineArrowForward></div>

                </div>

                {/* <a target='_blank'  href={'/politicas'}><div className='f-12 text-primary text-decoration-underline cursor-pointer text-center mt-3'>Aviso de privacidad</div></a> */}

                {/* <a target='_blank' href='https://www.bienvivirapp.com/home/privacy-policy/'><div className='f-14 bold text-primary text-decoration-underline cursor-pointer text-center mt-3'>Aviso de privacidad</div></a> */}

              </div>

            </div>

          </div>

          <div className='col d-md-block'>
            {/* <div className='bv-login-bg-na '> */}
            <div className='back-filter-login bacground-gray'>
              <img className='' src='assets/swinging_home.png'></img>
            </div>
            {/* </div> */}
          </div>

        </div>
      </div>
    </>
  )
}
